var map = {
	"./Accept.png": 714,
	"./NoImageAvailable.png": 351,
	"./Upload Car Image@3x.png": 715,
	"./add image.png": 716,
	"./back.png": 717,
	"./background.jpg": 718,
	"./bank.png": 719,
	"./butto online.png": 720,
	"./button .png": 721,
	"./call.png": 722,
	"./cancel.png": 723,
	"./car.png": 724,
	"./chat.png": 725,
	"./customer.png": 726,
	"./dashboard/chrome.png": 727,
	"./dashboard/contact-icon.png": 728,
	"./dashboard/download.png": 729,
	"./dashboard/files-icon.png": 730,
	"./dashboard/firefox.png": 731,
	"./dashboard/gallery.jpg": 732,
	"./dashboard/gallery.png": 733,
	"./dashboard/ie.png": 734,
	"./dashboard/light.jpg": 735,
	"./dashboard/light.png": 736,
	"./dashboard/mouse-icon-sm.png": 737,
	"./dashboard/mouse-icon.png": 738,
	"./dashboard/project-icon.png": 739,
	"./dashboard/rich-icon-sm.png": 740,
	"./dashboard/rich-icon.png": 741,
	"./dashboard/safari.png": 742,
	"./dashboard/shopping-bag-icon-sm.png": 743,
	"./dashboard/shopping-bag-icon.png": 744,
	"./dashboard/tasks-icon.png": 745,
	"./dashboard/teams-icon.png": 746,
	"./ddddd.png": 747,
	"./document.png": 748,
	"./drircation.png": 749,
	"./driver-location.png": 386,
	"./driver.png": 750,
	"./earning.png": 751,
	"./envelopePurolator.png": 532,
	"./fac icon.png": 752,
	"./favicon.ico": 753,
	"./golivro.png": 272,
	"./help support.png": 754,
	"./history.png": 755,
	"./home.png": 756,
	"./icon store.png": 757,
	"./iconnn.png": 758,
	"./image.png": 759,
	"./image1.png": 760,
	"./loading.gif": 387,
	"./locatin.png": 761,
	"./locked.png": 762,
	"./login image.png": 763,
	"./logo-color.png": 764,
	"./logo.png": 198,
	"./logo2.png": 765,
	"./logoo.png": 766,
	"./logout.png": 767,
	"./marker.png": 768,
	"./menu bar.png": 769,
	"./menu list.png": 770,
	"./menu-icon.png": 771,
	"./menu.png": 772,
	"./mesaage.png": 773,
	"./myrx.png": 270,
	"./no-bank.png": 774,
	"./no-docs.png": 775,
	"./no-image.png": 347,
	"./no-image.png_": 776,
	"./not-found.png": 342,
	"./offile imae.png": 777,
	"./password.png": 778,
	"./pentagon.png": 779,
	"./pentagon_1.png": 780,
	"./placeholder.jpg": 382,
	"./placeholder.png": 781,
	"./profiel scree.png": 782,
	"./profile 1.png": 783,
	"./profile.png": 784,
	"./purolator.png": 269,
	"./purolatorbox.png": 785,
	"./purolatorpack.png": 533,
	"./refund.png": 786,
	"./replaced.png": 787,
	"./sfwit.png": 788,
	"./text-message.gif": 789,
	"./tick icon.png": 790,
	"./track.png": 791,
	"./uber.png": 271,
	"./wallet.png": 792,
	"./widget/birds.png": 793,
	"./widget/bread.png": 794,
	"./widget/building.png": 795,
	"./widget/disc.png": 796,
	"./widget/flying.png": 797,
	"./widget/glass.png": 798,
	"./widget/noodles.png": 799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;